import { useNavigate } from 'react-router-dom';
import { Ban } from 'lucide-react';
import {
  Button,
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@design-system';

export function ConsumerNotAvailable() {
  const navigate = useNavigate();

  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <Empty className="animate-in fade-in slide-in-from-bottom-2 duration-200 ease-out motion-reduce:animate-none">
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <Ban />
          </EmptyMedia>
          <EmptyTitle>This page isn't available</EmptyTitle>
          <EmptyDescription>It isn't part of your account, or it may have moved.</EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Button onClick={() => navigate('/')}>Return to Home</Button>
        </EmptyContent>
      </Empty>
    </main>
  );
}
